<template>
	<div class="labeled-field-layout"
		:data-valid="isValid"
	>
		<div class="labeled-field-layout__label">
			<slot v-if="( label || $slots.label )" name="label">{{ label }}</slot>
			<slot v-if="( labelRight || $slots[ `label-right` ] )" name="label-right">{{ labelRight }}</slot>
		</div>
		<div class="labeled-field-layout__field">
			<slot></slot>
			<div v-if="$slots.popunder" class="labeled-field-layout__popunder-container">
				<slot name="popunder"></slot>
			</div>
		</div>
		<div
			v-if="( hint || $slots.hint ) && ( isValid || !validationErrorMessage )"
			class="labeled-field-layout__hint"
		>
			<slot name="hint">{{ hint }}</slot>
		</div>
		<div
			v-if="!isValid && validationErrorMessage"
			class="labeled-field-layout__validation-error"
		>
			<slot name="validationError">{{ validationErrorMessage }}</slot>
		</div>
	</div>
</template>

<script>
/** @abstract */
export default {
	name: "LabeledFieldLayout",
	props: {
		label: {
			type: String,
			default: "",
		},
		labelRight: {
			type: String,
			default: "",
		},
		hint: {
			type: String,
			default: "",
		},
		/** @type { message:String } */
		validationError: {
			type: Object,
			default: () => ( {} ),
		},
		isValid: {
			type: Boolean,
			default: true,
		},
	},
	computed: {
		validationErrorMessage() {
			return this.validationError?.message || "";
		},
	},
};
</script>

<style lang="scss" scoped>
$fontColor: $color1-700;
$hintFontColor: $color1-500;
$validationFontColor: $color7-500;

.labeled-field-layout {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	gap: 0.25rem;

	// minor padding needed to accommodate
	// box-shadow size
	padding: 0 0.1875rem;
}

.labeled-field-layout__label {
	@include font-and-line-for(0);
	font-weight: 600;
	text-align: left;
	color: $fontColor;

	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
}

.labeled-field-layout__field {
	display: inline-flex;
	width: 100%;
	position: relative;
	flex-direction: column;
	padding: 0.1875rem 0;

	span {
		width: 100%;
	}
}

.labeled-field-layout__hint {
	@include font-and-line-for(-1);
	text-align:left;
	color: $hintFontColor;
}

.labeled-field-layout__validation-error {
	@include font-and-line-for(-1);
	text-align:left;
	color: $validationFontColor;
}

.labeled-field-layout__popunder-container {
	position: absolute;
	top: 100%;
	width: 100%;
}
</style>
